<template>
  <layout :product="product"></layout>
</template>

<script>
import Layout from "./layout";

export default {
  components: {
    Layout
  },
  data() {
    return {
      product: "portal-beneficiario"
    };
  }
};
</script>
